import { render, staticRenderFns } from "./UploadServer.vue?vue&type=template&id=6f0f1b56&lang=pug&"
import script from "./UploadServer.vue?vue&type=script&lang=js&"
export * from "./UploadServer.vue?vue&type=script&lang=js&"
import style0 from "./UploadServer.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports